import { render, staticRenderFns } from "./ExamItemBox.vue?vue&type=template&id=d12cea04&"
import script from "./ExamItemBox.vue?vue&type=script&lang=js&"
export * from "./ExamItemBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/ExamItemBox.vue"
export default component.exports